module.exports = __webpack_public_path__ + "img/home_page_check_img.28a3772d.png";